import VerifyEmailResponse from '@/models/entities/api/authorization-resource/verify-email-response';
import { VERIFY_EMAIL_RESPONSE_TYPE } from '@/models/entities/api/authorization-resource/verify-email-response-type';

export default class VerifyEmailResponseDeleted extends VerifyEmailResponse {
  emailResponseType: typeof VERIFY_EMAIL_RESPONSE_TYPE.SUCCESSFULLY_DELETED;

  constructor(source: unknown) {
    super(source);
    if (this.parsedEmailResponseType !== VERIFY_EMAIL_RESPONSE_TYPE.SUCCESSFULLY_DELETED) {
      throw new Error('Improper (unvalidated) use of constructor.');
    }
    this.emailResponseType = this.parsedEmailResponseType;
  }
}
